var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTermsCloseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -72.4875,
    y: -72.4875,
    width: 184.975,
    height: 184.975
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(36.24px)",
      clipPath: "url(#bgblur_0_7691_32597_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 72.4875
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E4E4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6464 25.2558C13.2317 25.6705 13.2232 26.4068 13.6549 26.8385C14.095 27.2701 14.8313 27.2616 15.2375 26.8554L20.248 21.845L25.2499 26.8469C25.6731 27.2701 26.401 27.2701 26.8326 26.8385C27.2642 26.3984 27.2642 25.679 26.8411 25.2558L21.8391 20.2538L26.8411 15.2434C27.2642 14.8202 27.2727 14.0924 26.8326 13.6607C26.401 13.2291 25.6731 13.2291 25.2499 13.6523L20.248 18.6542L15.2375 13.6523C14.8313 13.2376 14.0865 13.2206 13.6549 13.6607C13.2232 14.0924 13.2317 14.8372 13.6464 15.2434L18.6484 20.2538L13.6464 25.2558Z",
    fill: "#3C3C43",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_7691_32597_clip_path",
    transform: "translate(72.4875 72.4875)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsCloseIcon);
export default __webpack_public_path__ + "static/media/terms-close-icon.fd8a31f2.svg";
export { ForwardRef as ReactComponent };